import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { GreenCheckMark } from 'Images';

export const AccessibleClinic = () => {
  return (
    <Stack direction='row' alignItems='center' gap='6px'>
      <Avatar
        alt=''
        src={GreenCheckMark}
        sx={{ width: '20px', height: '20px', mt: '1px' }}
      />
      <Typography
        variant='body2'
        sx={{
          cursor: 'text',
        }}
      >
        {Dictionary[DICTIONARY.Suppliers].resultPage.therapy.accessible}
      </Typography>
    </Stack>
  );
};
